module.exports = __webpack_public_path__ + "static/media/ico-profile-menu.7f056b63.svg";